import { useLayoutEffect } from 'react';
import type { ElvaChatThemeInput } from './types';
import { syncElvaChatTheme } from './syncElvaChatTheme';

/** Re-sync federated chat CSS variables whenever the host @elva/ui theme changes. */
export function useSyncElvaChatTheme(theme: ElvaChatThemeInput | null | undefined) {
  useLayoutEffect(() => {
    if (!theme) return;
    syncElvaChatTheme(theme);
  }, [theme, theme?.id, theme?.dark]);
}
